export default "__VITE_ASSET__DkE8D3OM__"